import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { Z_INDEX_MODAL } from '../../../../constants/constants';
import { SPECIAL_OFFERS_TEST_ID } from '../test-ids';
import { useSpecialOfferGiftModalControls } from '../useSpecialOfferModalControls';
import { GiftCell } from './compoents/GiftCell';
import { GiftGrid, ModalDescription } from './compoents/SpecialOfferModal.styles';

export const SpecialOfferGiftModal: FC = () => {
    const { t } = useTranslations();
    const { modalData, closeModal, isModalOpen } = useSpecialOfferGiftModalControls();
    const { cart } = useCartQuery();
    const benefits = cart?.potentialOfferPromotions?.flatMap((promotion) => promotion?.benefits);

    const buttons = [
        <Button key="close" variant="primary" onClick={closeModal} data-test={ESHOP_TEST_ID.MODAL_CLOSE_BTN}>
            {t['common.button.close']}
        </Button>,
    ];

    return (
        <Modal open={isModalOpen} onOpenChange={(open) => !open && closeModal()}>
            <Modal.Content
                title={modalData?.title}
                actions={<>{buttons}</>}
                stickyButtons={true}
                closeButtonAriaLabel={t['common.button.close']}
                showCloseButton={true}
                data-test={SPECIAL_OFFERS_TEST_ID.GIFT_MODAL}
                zIndex={Z_INDEX_MODAL}
            >
                <HtmlContent baseComponent={ModalDescription} content={modalData?.description} />
                <GiftGrid aria-label="pasiūlymų sqrašas">
                    {benefits?.map((benefit, index) => (
                        <GiftCell key={index} {...benefit} />
                    ))}
                </GiftGrid>
            </Modal.Content>
        </Modal>
    );
};
